import DictionariesService from "../../services/dictionaries";
import { SelectorStore } from "./selector-store";
import { message } from 'antd';
import { runInAction } from 'mobx';

export default class SelectrorItemStore {

    id: string;
    name: string;
    selectorStore: SelectorStore;
    dictionariesService: DictionariesService;

    constructor(id: string, name: string, selectorStore: SelectorStore) {
        this.id = id
        this.name = name;
        this.selectorStore = selectorStore;
        this.dictionariesService = new DictionariesService();
    }

    deleteItem(): void {
        try {
            this.dictionariesService.deleteItem(this.id, this.selectorStore.type).then(
                response => {
                    if (response.ok) {
                        this.selectorStore.loadDictionary();
                    } else {
                        response.json().then(error => message.error(error['detail']));
                    }
                }
            );
        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }
}